<template>
  <div class="medication-text-field">
    <v-text-field
        :disabled="!isEditable"
        v-model="computedValue"
        hide-details
        :placeholder="computedPlaceholder"
        outlined
        :error="error"
        dense
        :type="type"
        :min="min"
        :max="max"
        @keypress="onKeypress"
        @paste="onPaste"
        @focus="selectAll"
    ></v-text-field>
  </div>
</template>

<script>
/**
 * Component MedicationTextField.vue
 *
 * @module MedicationTextField
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationTextField.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationTextField',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    autoSelectAll: {
      type: Boolean,
      default: () => true,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    isSpecialPlaceholder: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: () => 'Text'
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    }
  },
  methods: {
    selectAll(event) {
      if (this.isEditable && this.autoSelectAll) {
        event.target.select();
      }
    },
    onKeypress(event) {
      this.$emit('onKeypress', event)
    },
    onPaste(event) {
      this.$emit('onPaste', event)
    },
  },
  computed: {
    componentClasses() {
      return {
        'medication-text-field': true,
        'medication-text-field--error': this.error,
      };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    computedPlaceholder() {
      if (this.isSpecialPlaceholder && !this.isEditable) {
        return this.placeholder;
      }

      return this.isEditable ? this.placeholder : '';
    },
  },
};
</script>
